import { ICreateAndUpdateCategory } from "../../../types/category.interface";
import { ICreateAndUpdateDriver } from "../../../types/driver.interface";
import {
  ICreateAndUpdateTicket,
  IReplyTicket,
} from "../../../types/ticket.interface";
import customAxios from "../../customAxios";
import { REPLY_TICKET } from "../../routes";
// import { PAY_DEBT_BY_ADMIN_PUT } from "../../routes";

const replyTicket = async (props: IReplyTicket) => {
  const body = {
    message: props?.message,
  };

  try {
    return (await customAxios.post(REPLY_TICKET + "/" + props._id, body)).data;
  } catch (error: unknown) {
    console.error({ CREATE_CATEGORY: error });
    return false;
  }
};

export default replyTicket;
